import { Outlet } from 'react-router-dom';

import deviceTrackingIcon from '@/assets/icons/hero-device-tracking.svg';
import fieldArc from '@/assets/icons/hero-field-arc.png';
import fieldMapIcon from '@/assets/icons/hero-field-map.svg';
import soilMoistureIcon from '@/assets/icons/hero-soil-moisture.svg';
import bg from '@/assets/images/auth-layout-bg.webp';
import bgPattern from '@/assets/images/BG Pattern.webp';
import logo from '@/assets/images/field-pro-logo.webp';

import styles from './auth-layout.module.scss';

export function AuthLayout() {
  return (
    <div className={styles.layout}>
      <aside className={styles.brand} style={{ backgroundImage: `url(${bg})` }}>
        <img src={logo} alt="FieldPro" className={styles.logo} />
        {/* 110180: the field boundary the design floats over the aerial photo — outline, 4
            corner dots, 2 dashed arcs sweeping to the soil-moisture pill, 2 leader stems, and
            the 3 map chips. One inline SVG, `viewBox="0 0 1440 813"` with
            `preserveAspectRatio="xMinYMid slice"` — anchors this layer with the same slice/cover
            semantics as the photo's own `background-position: 0% 50%`, so it scales identically
            to the photo at any viewport. Coordinates read off the storefront's own login page
            (the correct reference), with one deliberate deviation: the large top `decorFaint`
            outline rendered as a stray white-bordered rectangle at wide viewports and is
            dropped. The pill and arcs stay at the storefront's own coordinates — an earlier
            attempt to reposition them per misread feedback was reverted. */}
        <svg
          className={styles.heroDecor}
          viewBox="0 0 1440 813"
          preserveAspectRatio="xMinYMid slice"
          aria-hidden="true"
        >
          <g className={styles.decorFaint}>
            <svg x={619.6} y={249.6} width={237.277} height={202.852} viewBox="0 0 237.277 202.852">
              <path d="M236.486 119.021L231.88 3.84934L0.767813 0.778085V201.945L19.1953 198.874L13.8206 142.824L77.5491 132.074L140.51 151.269L236.486 119.021Z" />
            </svg>
          </g>
          <image
            href={fieldArc}
            x={411}
            y={256}
            width={126.5}
            height={93}
            preserveAspectRatio="none"
          />
          <g transform="translate(723.5, 258) scale(-1, 1)">
            <image
              href={fieldArc}
              x={0}
              y={0}
              width={126.5}
              height={93}
              preserveAspectRatio="none"
            />
          </g>
          <svg
            className={styles.decorPlot}
            x={315.1}
            y={242.3}
            width={306.571}
            height={209.008}
            viewBox="0 0 306.571 209.008"
          >
            <path d="M305.419 8.85715L34.381 1.17902L1.36504 173.937L305.419 207.721V8.85715Z" />
          </svg>
          <line className={styles.decorConnector} x1={332.09} y1={364.29} x2={332.09} y2={425.71} />
          <line className={styles.decorConnector} x1={809} y1={456.43} x2={809} y2={517.85} />
          <g className={styles.decorDot}>
            <circle cx={317.1} cy={414.71} r={6.14} />
            <circle cx={350.88} cy={244.26} r={6.14} />
            <circle cx={621.16} cy={253.47} r={6.14} />
            <circle cx={621.16} cy={450.03} r={6.14} />
          </g>
          <foreignObject x={255} y={270} width={280} height={96} overflow="visible">
            <span className={[styles.chip, styles.chipFieldMap].join(' ')}>
              <img src={fieldMapIcon} alt="" />
              Field Map
            </span>
          </foreignObject>
          <foreignObject x={655} y={362} width={320} height={96} overflow="visible">
            <span className={[styles.chip, styles.chipDevice].join(' ')}>
              <img src={deviceTrackingIcon} alt="" />
              Device Tracking
            </span>
          </foreignObject>
          <foreignObject x={521} y={221} width={280} height={108} overflow="visible">
            <span className={[styles.chip, styles.chipSoil].join(' ')}>
              <img src={soilMoistureIcon} alt="" />
              <span className={styles.chipReading}>
                <strong>28%</strong>
                <small>Soil Moisture</small>
              </span>
            </span>
          </foreignObject>
        </svg>
        <div className={styles.tagline}>
          <h2>Reliable insights for every acre</h2>
          <p>Built for modern agriculture</p>
        </div>
      </aside>
      <section className={styles.panel}>
        <img src={bgPattern} alt="bg-pattern" className={styles.bgPattern} />
        <main className={styles.outlet}>
          <Outlet />
        </main>
      </section>
    </div>
  );
}
